var React = require('react');

function Diamond (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.780571 950.857143c23.588571 0 35.584-15.853714 59.574858-48.420572l255.853714-341.577142c11.574857-15.853714 18.432-31.725714 18.432-48.859429 0-17.572571-6.857143-33.005714-18.432-48.859429L571.355429 121.142857C547.364571 88.996571 535.350857 73.142857 511.780571 73.142857c-23.131429 0-35.145143 15.853714-59.136 48L196.790857 463.140571c-11.574857 15.853714-18.432 31.286857-18.432 48.859429 0 17.152 6.857143 33.005714 18.432 48.859429l255.853714 341.577142C476.635429 934.985143 488.649143 950.857143 511.780571 950.857143z","stroke":"#36393D","strokeWidth":"6","fill":"#F9F7ED"}));
}

Diamond.defaultProps = {"t":"1640828421845","className":"icon","viewBox":"0 0 1024 1024","version":"1.1"};

module.exports = Diamond;

Diamond.default = Diamond;
